export default __webpack_public_path__ + "static/media/Team-Captain-Coach.4266e93d.gif";